/**
 * Detección de mezcla de servicios con y sin validación automática en un presupuesto
 * detallado (VEC-3738).
 *
 * Se usa para avisarle al usuario, antes de guardar, que las líneas de servicios con
 * validación automática se excluyen del total y que el resto se evalúa contra el monto
 * máximo de auto-aprobación — por lo que el presupuesto podría requerir aprobación manual.
 *
 * Vive fuera del componente para poder testearse sin montarlo. El llamador es responsable
 * de armar la lista COMPLETA de líneas: con `tickets.trabajaConManoDeObra.habilitado` los
 * ítems de mano de obra viven en un state separado del de repuestos, y si no se incluyen
 * la mezcla entre un repuesto y una mano de obra pasa desapercibida.
 */

/** Una línea es de validación automática si su servicio la tiene, o si la trae aplanada. */
export const esValidacionAutomatica = (linea) => {
	if (!linea) return false;
	if (linea.servicio && linea.servicio.validacion_automatica === 1) return true;
	return linea.validacion_automatica === 1;
};

/**
 * true sólo si conviven líneas de servicios CON validación automática y líneas SIN ella.
 * Un presupuesto vacío, o uno donde todas las líneas son del mismo tipo, no es mezcla.
 *
 * @param {Array<Object>} lineas ítems (repuestos + mano de obra) y tareas del presupuesto
 * @returns {boolean}
 */
export const tieneMezclaValidacionAutomatica = (lineas) => {
	if (!lineas || lineas.length === 0) return false;

	let tieneConValidacion = false;
	let tieneSinValidacion = false;

	lineas.forEach((linea) => {
		if (esValidacionAutomatica(linea)) {
			tieneConValidacion = true;
		} else {
			tieneSinValidacion = true;
		}
	});

	return tieneConValidacion && tieneSinValidacion;
};
